<template>
  <div class="hotCases">
    <div class="hotCases-title" v-show="isFlag">
      <div class="hotCases-titleR">热门病例</div>
      <div class="hotCases-titleL fontColor" @click="goList">全部病例<van-icon name="arrow" /></div>
    </div>
    <div class="hotCases-title" v-show="isallCases">
      <div class="filter-casesNum fontColor">{{ casesNum }} 病例</div>
      <div class="hotCases-toggle">
        <span
          class="weui-switch"
          :class="{ 'weui-switch-on': isChecked }"
          @click="toggle()"
          style="position: relative"
        >
          <div class="hottest">最热</div>
          <div class="newest">最新</div>
        </span>
      </div>
    </div>
    <div class="hotCases-title casesPosition" v-show="isFold">
      <div class="casesText">{{ tabNames }}</div>
      <div class="casesText">全部类型</div>
    </div>
    <div class="hotCases-content" ref="casesList">
      <MedicaseItem
        class="mt-32"
        v-for="(item, key) in list"
        :key="key"
        :item="item"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import MedicaseItem from '@com/list/medicaseItem.vue'
import { hotMedicase, searchMedicase } from '@api/exercise'
import { isLogin, userLogin, queryToString } from '@/widget/index'
export default defineComponent({
  props: {
    isFlag: {
      type: Boolean,
      default: true
    },
    isallCases: {
      type: Boolean,
      default: false
    },
    flag: {
      type: Boolean,
      default: true
    },
    tabValue: {
      type: Number
    },
    pageNum: {
      type: Number,
      default: 1
    },
    tabName: {
      type: String,
      default: '全部'
    }
  },
  data() {
    return {
      list: [],
      isChecked: true,
      isFold: false,
      casesNum: 0,
      departmentId: this.$route.query.depId || '',
      filter: 'HOT',
      tagId: null,
      tabNames: '全部',
      pageNums: 1,
      isLogin: isLogin
    }
  },
  watch: {
    pageNum(newData) {
      this.pageNums = newData
      this.searchMedicase()
    }
  },
  computed: {
    successPage() {
      return this.$route.name === 'successVip'
    }
  },
  methods: {
    toggle() {
      this.isChecked = !this.isChecked
      if (this.isChecked === false) {
        this.filter = 'LATEST'
      } else {
        this.filter = 'HOT'
      }
      this.searchMedicase()
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop >= 200) {
        this.isFold = true
      } else {
        this.isFold = false
      }
    },
    hotMedicase(val) {
      if (!this.flag) {
        return
      }
      if (val && val !== 0) {
        this.departmentId = val
      } else if (val === 0) {
        /*  val === 0查看全部 */
        this.departmentId = ''
      }
      this.$showLoading()
      this.$emit('getFlag', false)
      hotMedicase({
        departmentId: this.departmentId
      }).then(res => {
        this.$emit('getFlag', true)
        this.$hideLoading()
        if (res.code === 200) {
          this.list = res.data
          this.casesNum = res.data.length
        } else {
          this.$toast(res.message)
        }
      })
    },
    searchMedicase(val) {
      if (!this.flag) {
        return
      }
      if (val) {
        this.tabNames = val.tabName
        this.tagId = val.tagId
      }
      this.$showLoading()
      this.$emit('getFlag', false)
      searchMedicase({
        filter: this.filter,
        tagId: this.tagId,
        page: this.pageNums
      }).then(res => {
        this.$emit('getFlag', true)
        this.$hideLoading()
        if (res.code === 200) {
          this.list = res.data.items
          this.casesNum = res.data.total
          this.$emit('pageCounts', res.data.pages)
          if (this.pageNums === 1) {
            // 是否需要上拉加载
            this.scroll = res.data.pages > 1
          }
          this.$emit('scrollStatus', this.scroll)
          this.$emit('serchLength', this.casesNum)
        } else {
          this.$toast(res.message)
        }
      })
    },
    goList() {
      let query = this.$route.query
      if (!this.isLogin) {
        userLogin()
        return
      }
      this.$router.push({
        name: 'medicaseList',
        query
      })
    }
  },
  mounted() {
    /* 监听（绑定）滚轮滚动事件 */
    this.$nextTick(() => {
      if (this.isallCases === true) {
        window.addEventListener('scroll', this.handleScroll)
      } else if (this.isFlag === true) {
        this.hotMedicase()
      }
    })
  },
  components: {
    MedicaseItem
  }
})
</script>
<style scoped>
.van-icon {
  font-size: 28px;
  color: inherit;
}
</style>
<style lang="scss" scoped>
.hotCases {
  margin: 0.32rem 0.32rem 0;
  padding-bottom: 0.5rem;
  .fontEllipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
}
.fontColor {
  font-family: PingFangSC-Regular, PingFang SC;
  color: #969799;
  font-weight: 400;
}
.hotCases-title {
  display: flex;
  justify-content: space-between;
  height: 64px;
  align-items: center;
  .hotCases-titleR {
    font-size: 0.4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #212224;
    line-height: 0.64rem;
  }
  .hotCases-titleL {
    font-size: 0.28rem;
    a {
      display: inline-block;
      height: 100%;
      line-height: 0.64rem;
      padding-right: 0.26rem;
      background: url('~@/assets/icon/iconRight.png') no-repeat right center;
      background-size: 0.2rem 0.2rem;
    }
    img {
      width: 0.2rem;
      height: 0.2rem;
    }
  }
  .filter-casesNum {
    color: #212224;
    font-size: 24px;
    line-height: 64px;
  }
  .hotCases-toggle {
    line-height: 64px;
  }
}
.hotCases-content {
  width: 686px;
  margin: 0 auto 0;
  overflow: hidden;
}
.weui-switch {
  display: block;
  position: relative;
  width: 200px;
  height: 64px;
  outline: 0;
  background: #e1e2e6;
  border-radius: 32px;
  box-sizing: border-box;
  transition: background-color 0.1s, border 0.1s;
  cursor: pointer;
}
.weui-switch:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 64px;
  border-radius: 32px;
  transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
}
.weui-switch:after {
  content: ' ';
  position: absolute;
  top: 3px;
  right: 10px;
  width: 98px;
  height: 56px;
  background: #ffffff;
  border-radius: 28px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
}
.weui-switch-on {
  background: #e1e2e6;
}
.weui-switch-on:before {
  background: #e1e2e6;
}
.weui-switch-on:after {
  transform: translateX(-85px);
}
.hottest {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0 5px;
  left: 26px;
  user-select: none;
  line-height: 64px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #212224;
  z-index: 9;
}
.newest {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0 5px;
  right: -125px;
  line-height: 64px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #212224;
  user-select: none;
  z-index: 9;
}
.casesPosition {
  position: fixed;
  top: 87px;
  width: 6.86rem;
  height: 88px;
  background: #f5f5f7;
  box-sizing: border-box;
  z-index: 99;
}
.casesText {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626366;
  line-height: 88px;
}
</style>
